<template>
<div v-if="!loginInfo">
  <span class="bg"></span>

  <v-row justify="center">
  <v-col cols="12" sm="10" md="8" lg="6">
  <v-card v-if="message" style="text-align:center" color="orange darken-1" id="login-error" class="mx-auto white--text">
    <v-card-subtitle class="mx-auto white--text">
      {{message}}
    </v-card-subtitle>
  </v-card>
  </v-col>
  </v-row>
  <v-row justify="center" class="my-10">
  <v-col cols="12" sm="9" md="6" lg="5">
  <v-card  class="px-2 px-sm-4 px-md-6" v-if="gosgLogin">
    <v-card-title class="big-title"><h4 class="card-title white-font">Government Online Services Gateway (GOSG)</h4>
    <img alt="Government of Malaysia" src="../assets/coat-of-arms.png" style="height:60pt" /></v-card-title>
    <v-card-text>
       <div class="add-margin">
        To participate as a <em>Biz4WRD</em> user,
        please choose <em>Login</em> if you already have an
        account with the
        <em>Government Online Services Gateway</em> (GOSG).
        Otherwise, please choose
        <em>Register an Account</em>. You will also have access
        to other services at the <em>MyGovernment</em> portal too!
      </div>
      <div class="more-info mt-1" style="text-align:right !important; width:100%;font-style:italic">
        <a @click="moreInfo()">
          More info...
        <iconify class="mr-1" style="color: #2196f3;font-size: 14px;" icon="ic:baseline-open-in-new" />
        </a>
      </div>
    </v-card-text>

    <v-card-actions>
      <v-row justify="end" dense class="text-center">
      <v-col cols="12" sm="6">
      <v-btn
        color="success"
        width="100%"
        v-bind:href="aposBase + forwardPath"
      >
        login
      </v-btn>
      </v-col>
      <v-col cols="12" sm="6">
      <v-btn
      color="grey darken-1"
      width="100%"
      class="white--text"
      v-bind:href="registerUrl"
      >
        Register An Account
      </v-btn>
      </v-col>
      <v-col cols="12">
      <div
        v-if="localLogin"
        class="more-info my-2"
        style="text-align:right !important; width:100%">
        <a @click="toggleLogin()" style="color:#bdbdbd;margin-right:15px;padding-top:20px">
          Internal Login >
        </a>
      </div>
      </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
  <v-card class="px-2 px-sm-4 px-md-10" v-else-if="localLogin">
    <v-card-title class="big-title"><h4 class="card-title white-font">Internal Login</h4></v-card-title>
      <v-card-text>
      <v-form class="mx-auto" width="90%" method="post" :action="aposBase + '/login'" id="loginForm" ref="loginForm">
      <v-text-field
            label="Email..."
            prepend-icon="face"
            name="username"
            id="username"
          ></v-text-field>
      <v-text-field
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            class="input-group--focused"
            @click:append="showPassword = !showPassword"
            label="Password"
            prepend-icon="lock_outline"
            name="password"
            id="password"
            v-on:keyup.enter="submit"
          ></v-text-field>
      </v-form>
      </v-card-text>

      <v-card-actions>
        <v-row justify="end" dense class="text-center">
        <v-col cols="12" md="6" lg="4">
        <v-btn
        block
        color="success"
        class="mx-auto"
        @click="submit"
        width="100%"
      >login</v-btn>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-btn
         color="blue lighten-1"
        class="mx-auto white--text"
        v-bind:href="aposBase + '/signup'"
        width="100%"
        >Register an Account</v-btn>
      </v-col>

      <v-col cols="12" md="6" lg="4">
      <v-btn
        color="grey darken-1"
        class="white--text"
        v-bind:href="aposBase + '/password-reset-request'"
        width="100%"
      >Forgot Password</v-btn>
      </v-col>
      <v-col cols="12">
      <div class="more-info mt-1" style="text-align:right !important; width:100%;margin-top:15px">
        <a @click="toggleLogin()" style="color:#bdbdbd;margin-right:15px;padding-top:20px">
          GOSG Login >
        </a>
      </div>
      </v-col>
      </v-row>
      </v-card-actions>
  </v-card>
  </v-col>
  </v-row>
</div>
</template>


<script>
import { Icon } from '@iconify/vue2'

export default {
    name: 'Login',
    components:{
       Iconify: Icon,
    },

    data: () => ({
      gosgLogin:true,
      showPassword: false,
    }),
    watch: {
      loginInfo(val) {
        if (val) {
          window.location.replace('/login')
        }
      }
    },
    computed:{
      loginInfo() {
        const up = this.$root.userProfile
        const info = up && up._loginInfo
        return info && info.data && info.data.infoString
      },
      host(){
        return document.host
      },
      protocol(){
        return document.protocol
      },
      baseUrl(){
        return this.protocol +'//'+this.host
      },
      localLogin(){
        return !!process.env.VUE_APP_LOCAL_LOGIN
      },
      forwardUrl() {
        return window.location.origin + process.env.VUE_APP_FORWARD_PATH;
      },
      registerUrl() {
        return (
            process.env.VUE_APP_REGISTER_URL + "?forward_url=" + this.forwardUrl
        );
      },
      forwardPath(){
        return process.env.VUE_APP_FORWARD_PATH
      },
      aposBase(){
        return window.location.origin
      },
      message(){
        return this.$route.query.message || null
      }
    },
    mounted(){
      this.gosgLogin = !this.$route.query.message
    },
    methods:{
      moreInfo(){
        window.open(process.env["VUE_APP_MOREINFO_URL"])
      },
      toggleLogin(){
        this.gosgLogin = !this.gosgLogin
      },
      submit(){
        this.$refs['loginForm'].$el.submit()
      }
    }
  }
  /* $(function() {
    {% if data.message %}
    $('#uap-login').addClass('d-none')
    $('#int-login').removeClass('d-none')
    {%  else %}
    $('#uap-login').removeClass('d-none')
    $('#int-login').addClass('d-none')
    {%  endif %}

  })
  function toggleLogin() {
    $('#uap-login').toggleClass('d-none')
    $('#int-login').toggleClass('d-none')
    $('#login-error').addClass('d-none')
    if (window.history.replaceState) {
      window.history.replaceState(null, 'Login', '{{ apos.prefix }}/login')
    } else {
      document.location.href = '{{ apos.prefix }}/login'
    }
    return false;
  } */
</script>
<style scoped>
.bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: url('../assets/img/b4w/Industry4WRD-04.png') no-repeat center center;
    background-size: cover;
    filter:brightness(50%)
  }

  .big-title {
    width: 90%;
    /*border-radius: 70px;*/
    margin-left: 5%;
    margin-right: 10%;
    margin-top: -30pt;
    /*background: cornflowerblue;*/
    background: rgb(114,178,240);
    background: linear-gradient(90deg, rgba(114,178,240,1) 0%, rgba(78,155,237,1) 100%);
    /* height: 130pt; */
    display: inline-block;
    position: relative;
    text-align: center;
    /*padding-bottom: 3rem;*/
  }

  .white-font{
    color: white !important;
    font-size: 1.125rem;
    text-align: center;
    word-break: break-word;
  }

  .add-margin{
    margin-top: 1.5rem !important;
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
    margin-bottom: 1rem !important;
  }

  a:link {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

a:active {
  text-decoration: underline;
}
.wide-button{
   width: 49%;
/*    margin-left:5%;
   margin-top: 5%;
   ; */
}
.v-btn{
  letter-spacing: 0 !important;
  font-size: 0.6rem !important;
}
</style>
